<template>
  <tr
    v-if="isOpen && comments && comments.length > 0"
    class="border-b border-gray-200 bg-gray-50"
  >
    <td
      :colspan="colspan"
      class="p-4"
    >
      <div class="space-y-3">
        <h4 class="text-sm font-medium text-gray-700">{{ title }}</h4>
        <div
          v-for="comment in comments"
          :key="comment.id"
          class="rounded-md border border-gray-200 bg-white p-3"
        >
          <div class="mb-2 flex items-center justify-between">
            <div class="flex items-center gap-2">
              <span
                class="rounded-full px-2 py-1 text-xs font-medium"
                :class="{
                  'bg-blue-100 text-blue-800': comment.commentType === 'general_comment',
                  'bg-orange-100 text-orange-800': comment.commentType === 'delay_comment',
                }"
              >
                {{ getCommentTypeLabel(comment.commentType) }}
              </span>
              <span class="text-xs text-gray-500">
                {{ getSenderTypeLabel(comment.senderType) }}
              </span>
            </div>
            <span class="text-xs text-gray-400">
              {{ formatDate(comment.createdAt) }}
            </span>
          </div>
          <p class="text-sm text-gray-700">{{ comment.content }}</p>
          <p
            v-if="comment.senderName"
            class="mt-1 text-xs text-gray-500"
          >
            - {{ comment.senderName }}
          </p>
        </div>
      </div>
    </td>
  </tr>
</template>

<script lang="ts" setup>
interface CommentsContentProps {
  comments?: SubOrderComment[];
  colspan?: number;
  title?: string;
  isOpen?: boolean;
}

withDefaults(defineProps<CommentsContentProps>(), {
  comments: () => [],
  colspan: 9,
  title: 'Comentarios:',
  isOpen: false,
});

const getCommentTypeLabel = (commentType: string): string => {
  if (commentType === 'delay_comment') {
    return 'Atraso';
  }
  if (commentType === 'general_comment') {
    return 'General';
  }
  return commentType;
};

const getSenderTypeLabel = (senderType: string): string => {
  if (senderType === 'Shop') {
    return 'Tienda';
  }
  if (senderType === 'Maker') {
    return 'Marca';
  }
  if (senderType === 'Lokal') {
    return 'Lokal';
  }
  return senderType;
};

const formatDate = (dateString: string): string => {
  return new Date(dateString).toLocaleDateString();
};
</script>
